import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import CreateAR from '../../components/AR/createAR';
import { fetchCustomers, fetchCustomerDetail } from '../../actions/customers_actions';

import { fetchARInvoices, createAR, refundAR, fetchARCredits, clearCredits, clearARForm, changeField, clearARDetail } from '../../actions/arap_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

const isNumeric = function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = (values) => {
  const errors = {};
  if (values.TotalPayment && !isNumeric(values.TotalPayment)) {
    errors.TotalPayment = 'Accept number only!';
  }

  if (values.TotalPayment < 0) {
    errors.TotalPayment = 'Positive number only!';
  }

  if (values.Discount && !isNumeric(values.Discount)) {
    errors.Discount = 'Accept number only!';
  }

  if (values.Discount && values.Discount < 0) {
    errors.Discount = 'Positive number only!';
  }

  if (values.PenaltyAmount && !isNumeric(values.PenaltyAmount)) {
    errors.PenaltyAmount = 'Accept number only!';
  }

  if (values.PenaltyAmount && values.PenaltyAmount < 0) {
    errors.PenaltyAmount = 'Positive number only!';
  }

  if (values.waiveAmount && !isNumeric(values.waiveAmount)) {
    errors.waiveAmount = 'Accept number only!';
  }

  if (!values.Customer) {
    errors.Customer = 'Required';
  }

  if (!values.Account) {
    errors.Account = 'Required';
  }

  if (!values.TotalPayment) {
    errors.TotalPayment = 'Required';
  }

  if (!values.Method) {
    errors.Method = 'Required';
  }

  if (!values.PaymentDate) {
    errors.PaymentDate = 'Required';
  }

  return errors;
};

const createARForm = reduxForm({
    form: 'createAR',
    enableReinitialize: true,
    destroyOnUnmount: false,
    touchOnChange: true,
    touchOnBlur: false,
    validate,
})(CreateAR);

const selector = formValueSelector('createAR');

function mapStateToProps(state) {
    const customer_id = selector(state, 'Customer');
    const credits = selector(state, 'Credits');

    const invoiceDate = selector(state, 'InvoiceDate');
    const paymentDate = selector(state, 'PaymentDate');
    const fromDate = selector(state, 'FromDate');
    const toDate = selector(state, 'ToDate');
    const penaltyAmount = selector(state, 'PenaltyAmount');

    const method = selector(state, 'Method');
    const checkNum = selector(state, 'CheckNum');
    const account = selector(state, 'Account');
    const discount = selector(state, 'Discount');
    const totalPayment = selector(state, 'TotalPayment');
    const waive = selector(state, 'Waive');
    const note = selector(state, 'Note');
    return {
        customer_id,
        credits,
        invoiceDate,
        paymentDate,
        fromDate,
        toDate,
        penaltyAmount,
        method,
        checkNum,
        account,
        discount,
        totalPayment,
        waive,
        note,
        invoices: state.arap.invoices,
        invoicesIsLoading: state.arap.invoicesIsLoading,
        invoicesError: state.arap.invoicesError,
        arCreated: state.arap.arCreated,
        arCreateError: state.arap.arCreateError,
        arIsCreating: state.arap.arIsCreating,

        arIsRefunding: state.arap.arIsRefunding,
        arRefunded: state.arap.arIsRefunded,
        arRefundError: state.arap.arRefundError,

        credits: state.arap.credits,
        creditsIsLoading: state.arap.creditsIsLoading,
        creditsError: state.arap.creditsError,

        customers: state.customers.all,
        customersIsLoading: state.customers.isLoading,
        customersError: state.customers.error,
        currentCustomerDetail: state.customers.currentCustomerDetail,
        userPermissions: state.auth.userPermissions,
        checkPassword: state.settings.checkPassword,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,
    };
}


export default connect(mapStateToProps, {
    fetchARInvoices,
    createAR,
    refundAR,
    fetchCustomers,
    fetchCustomerDetail,
    fetchARCredits,
    clearCredits,
    clearARForm,
    checkPassword,
    clearCheckPassword,
    setDefaultOfForm,
    clearARDetail,
    changeField
  })(createARForm);



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/createAR.jsx